"use client";

import { useLanguage } from "@/contexts/LanguageContext";
import { GTMEvents, GTMSubEvents, PushDataToGTM } from "@/lib/gtm";
import Image from "next/image";

const pillBase =
  "inline-flex shrink-0 items-center gap-2 rounded-lg border border-[#E5E5E5] bg-white px-3 py-2 text-sm transition-colors hover:bg-[#FAFAFA] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#DD0428]/25 focus-visible:ring-offset-2";

type NavLanguageSwitcherProps = {
  /** GTM `pageName` / menu context */
  analyticsPageName: "DESKTOP HEADER" | "MOBILE HEADER";
  className?: string;
};

export function NavLanguageSwitcher({
  analyticsPageName,
  className,
}: NavLanguageSwitcherProps) {
  const { locale, setLocale, t } = useLanguage();

  const toggle = () => {
    const next = locale === "en" ? "ar" : "en";
    if (next === "en") {
      PushDataToGTM(GTMEvents.DataLayerUpdate, {
        pageName: analyticsPageName,
        pageCategory: analyticsPageName,
        eventCategory: GTMSubEvents.Click,
        eventLabel: `${analyticsPageName} > LANGUAGE EN`,
      });
    } else {
      PushDataToGTM(GTMEvents.DataLayerUpdate, {
        pageName: analyticsPageName,
        pageCategory: analyticsPageName,
        eventCategory: GTMSubEvents.Click,
        eventLabel: `${analyticsPageName} > LANGUAGE AR`,
      });
    }
    setLocale(next);
  };

  /** Show the language you will switch *to* (inverse of current locale). */
  if (locale === "en") {
    return (
      <button
        type="button"
        onClick={toggle}
        className={`${pillBase} ${className ?? ""}`}
        aria-label={t("nav.switchToArabic")}
        dir="ltr"
      >
        <span
          className="flex h-[18px] w-[26px] shrink-0 items-center justify-center text-[15px] leading-none"
          aria-hidden
        >
          🇸🇦
        </span>
        <span className="font-semibold text-[15px] text-[#3A3A3C]">عربي</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className={`${pillBase} ${className ?? ""}`}
      aria-label={t("nav.switchToEnglish")}
      dir="ltr"
    >
      <span className="text-sm font-bold tracking-wide text-[#130F0E]">EN</span>
      <Image src="/images/en-icon.svg" alt="English" className="h-5 w-5 shrink-0" width={20} height={20}/>
    </button>
  );
}
